import { useCallback, useState } from "react";
import { toast } from "sonner";

interface EthereumProvider {
  request: (args: { method: string; params?: unknown[] | object }) => Promise<unknown>;
}

declare global {
  interface Window {
    ethereum?: EthereumProvider;
  }
}

export function truncateAddr(a: string, head = 6, tail = 4): string {
  return a.length > head + tail + 1 ? `${a.slice(0, head)}…${a.slice(-tail)}` : a;
}

/** Lightweight browser-native wallet connect (EIP-1193). No SDK, no backend session. */
export function useWalletConnect() {
  const [address, setAddress] = useState<string | null>(null);

  const connect = useCallback(async () => {
    const eth = typeof window !== "undefined" ? window.ethereum : undefined;
    if (!eth) {
      toast("No wallet detected", {
        description: "Install MetaMask or open this site in a wallet-enabled browser.",
      });
      return;
    }
    try {
      const accounts = (await eth.request({ method: "eth_requestAccounts" })) as string[];
      if (accounts?.length) {
        setAddress(accounts[0]);
        toast("Wallet connected", { description: truncateAddr(accounts[0]) });
      }
    } catch {
      toast("Wallet connection was cancelled");
    }
  }, []);

  return { address, connect };
}
